import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const whatsappNumber = '5561985533770';
  const message = 'Olá! Gostaria de saber mais sobre os serviços do Estúdio Hertz.';

  useEffect(() => {
    // Show button after a delay
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Show tooltip briefly after button appears
      setTimeout(() => setShowTooltip(true), 500);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleClick = () => {
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex items-center space-x-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="hidden md:flex items-center bg-white rounded-lg shadow-2xl px-4 py-3 animate-fade-in border-2 border-[#25D366]/20">
          <div className="mr-3">
            <p className="text-sm font-semibold text-[#1e3a5f]">Precisa de ajuda?</p>
            <p className="text-xs text-gray-600">Fale conosco no WhatsApp!</p>
          </div>
          <button
            onClick={() => setShowTooltip(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleClick}
        className="group relative w-16 h-16 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-2xl hover:shadow-[#25D366]/50 flex items-center justify-center transform hover:scale-110 transition-all duration-300 animate-bounce-slow"
        aria-label="Abrir WhatsApp"
      >
        {/* Pulse animation */}
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75"></span>
        
        {/* Icon */}
        <MessageCircle className="text-white relative z-10" size={28} fill="white" />
        
        {/* Badge */}
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-[#ff6b35] rounded-full flex items-center justify-center text-white text-xs font-bold animate-pulse">
          1
        </span>
      </button>
    </div>
  );
};

export default WhatsAppButton;